import { getMentionUsers, addStickyNote } from '../../../../services/popupApi';

export const api = {
  getMentionOptions: async (_field, search) => getMentionUsers(search),
  submit: async (values, context) => {
    const mentioned = (values.comments?.match(/@([\w.]+)/g) ?? []).map((m) => m.slice(1));
    await addStickyNote({
      relatedIds: context.selectedIds,
      module: context.moduleName,
      title: values.heading,
      targetDate: values.targetDate ? values.targetDate.toISOString() : '',
      notes: values.comments,
      mentionedUsers: mentioned,
    });
  },
};
